import React from 'react';
import './AdminLayout.css';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../AdminSidebar/AdminSidebar';
import { useOpen } from '../../../context/OpenContext';

const AdminLayout = () => {
  const [open] = useOpen();
  return (
    <div className="admin-layout-container" data-testid="admin-layout-container">
      <AdminSidebar />
      <div
        style={{
          marginLeft: open ? '14rem' : '5rem',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          overflowX: 'hidden',
        }}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
